import { useTranslate } from "@similarweb/i18n-provider";
import { WebsiteBlue } from "@similarweb/icons/illustrations";
import { Button, PromoBanner } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import IntegrationButtonWrapper from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-button/IntegrationButtonWrapper";
import { MANAGE_INTEGRATIONS_CARD_UPGRADE } from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";
import { useSignalsIntegrationActions } from "app/pages/sales-intelligence/modules/manage-integrations/hooks/useSignalsIntegrationActions";

export const SignalsIntegrationBanner = () => {
    const { translate } = useTranslate();
    const { webhook, restApi } = useSignalsIntegrationActions();

    return (
        <PromoBanner data-automation="account-signals-integration-banner">
            <WebsiteBlue size={80} />
            <PromoBanner.Content>
                <PromoBanner.Title>{translate("si.account-signals.management.integration.title")}</PromoBanner.Title>
                <PromoBanner.Description>
                    {translate("si.account-signals.management.integration.description")}
                </PromoBanner.Description>
            </PromoBanner.Content>
            <Flex
                gap="8px"
                alignItems="center"
                flexShrink={0}
            >
                <IntegrationButtonWrapper
                    dataAutomationNameSpace="account-signals-integration-api"
                    isEnabled={restApi.isAccountEnabled}
                    upgradeButtonText={translate(MANAGE_INTEGRATIONS_CARD_UPGRADE)}
                    onUpgradeClick={restApi.onUpgradeClick}
                >
                    <Button
                        buttonHtmlType="button"
                        type={restApi.isConfigured ? "outlined" : "primary"}
                        onClick={restApi.onManageClick}
                        dataAutomation="account-signals-integration-api.integration-card-manage-button"
                    >
                        {translate("si.account-signals.management.integration.api.docs")}
                    </Button>
                </IntegrationButtonWrapper>
                <IntegrationButtonWrapper
                    dataAutomationNameSpace="account-signals-integration-webhooks"
                    featureName="signalsWebhook"
                    hasAccess={webhook.hasAccess}
                    isEnabled={webhook.isEnabled}
                    onUpgradeClick={webhook.onUpgradeClick}
                >
                    <Button
                        buttonHtmlType="button"
                        type={webhook.isConfigured ? "outlined" : "primary"}
                        onClick={webhook.onManageClick}
                        dataAutomation="account-signals-integration-webhooks.integration-card-manage-button"
                    >
                        {translate("si.account-signals.management.integration.webhooks")}
                    </Button>
                </IntegrationButtonWrapper>
            </Flex>
        </PromoBanner>
    );
};
